import type { AppLanguage } from "./index";
import { SPANISH_TRANSLATIONS } from "@/services/location/constants/translations";

type LocationType = keyof typeof SPANISH_TRANSLATIONS;

const englishNamesBySpanishName = Object.fromEntries(
  (Object.keys(SPANISH_TRANSLATIONS) as LocationType[]).map((type) => [
    type,
    Object.fromEntries(
      Object.entries(SPANISH_TRANSLATIONS[type]).map(([english, spanish]) => [
        spanish,
        english,
      ])
    ),
  ])
) as Record<LocationType, Record<string, string>>;

export const getLocalizedLocationName = (
  name: string,
  type: LocationType,
  language: AppLanguage
): string => (language === "en" ? englishNamesBySpanishName[type][name] || name : name);
